const formatDisplayId = (id: string) => `#${id}`;

export default formatDisplayId;
